import type { SubscriptionPlanDto } from '@_/api-contracts/common.ts';
import { planContents } from './plans.ts';

export function mergeOrgPlanContent(plan: SubscriptionPlanDto) {
  const content = planContents.find(c => c.code === plan.code);

  if (!content) {
    throw new Error(`Plan content not found for code: ${plan.code}`);
  }

  return {
    ...plan,
    ...content
  };
}
